module.exports = __webpack_public_path__ + "static/media/duolingo.0003d906.png";